<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="AlertIcon" alt="Alert Icon" width="40" height="40" />
      </div>
      <h4>{{ $t('purchase_plans.modal_messages.load_error_title') }}</h4>
      <p class="m-0 text-muted">{{ loadErrorDescription }}</p>
    </div>
    <template #modal-footer>
      <div class="d-flex gap-3 w-100">
        <b-button
            :disabled="reloading"
            class="w-50"
            variant="light"
            @click="hide"
        >
          {{ $t('Close') }}
        </b-button>
        <b-button
            :disabled="reloading"
            class="w-50 m-0"
            variant="primary"
            @click="handleRetry"
        >
          <b-spinner v-if="reloading" class="me-2" small></b-spinner>
          {{ lodash.startCase($t('Retry')) }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import AlertIcon from '@/assets/icons/AlertIcon.svg'

export default {
  name: 'purchase-plan-load-error-dialog',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-load-error-dialog-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      AlertIcon,
      planId: null,
      reloading: false,
    };
  },
  computed: {
    loadErrorDescription() {
      const planId = this.planId

      if (planId === null || planId === undefined || `${planId}`.trim() === '') {
        return this.$t('purchase_plans.modal_messages.load_error_description_no_id')
      }

      return this.$t('purchase_plans.modal_messages.load_error_description', {id: planId})
    },
  },
  methods: {
    show(planId = null) {
      this.planId = planId
      this.reloading = false
      this.$bvModal.show(this.id)
    },
    hide() {
      if (this.reloading) return
      this.$bvModal.hide(this.id)
    },
    handleRetry() {
      this.reloading = true
      window.location.reload()
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
